<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";
  import emailjs from "@emailjs/browser";

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="moapp1">
  <img src="/img/17.jpg" alt="Mobile Development" class="background-image" />
  <div class="text-overlay">Web Development</div>
</div>

<div class="sof2d">
  <div class="leftso">
    <img src="/img/18.jpg" alt="Web Development Image" class="leftso-image" />
  </div>
  <div class="rightso">
    <h1 class="rightso-title">Web Development Crafted<br />for Your Business</h1>
    <div class="rightso-content">
      <div class="leftri">
        <p class="number">01.</p>
        <h2 class="dev-title">Java Development</h2>
        <p class="dev-text">
          We deliver scalable,<br />high-performance Java solutions<br />for enterprise applications<br />and web platforms.
        </p>
        <p class="number">03.</p>
        <h2 class="dev-title">C++ Development</h2>
        <p class="dev-text">
          We provide efficient,<br />reliable C++ solutions for<br />complex backend systems.
        </p>
      </div>
      <div class="rightri">
        <p class="number">02.</p>
        <h2 class="dev-title">PHP Development</h2>
        <p class="dev-text">
          We build secure, fast PHP<br />applications that power dynamic<br />websites with seamless integration.
        </p>
        <p class="number">04.</p>
        <h2 class="dev-title">.NET Development</h2>
        <p class="dev-text">
          We create scalable .NET<br />applications that streamline<br />business processes and enhance<br />user experiences.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="sof4">
  <div class="card">
    <i class="fas fa-check-circle"></i>
    <div class="card-text">
      <p>Machine Learning & AI</p>
      <p>We implement intelligent systems that analyze data, predict outcomes, and optimize business workflows.</p>
    </div>
  </div>
  <div class="card">
    <i class="fas fa-check-circle"></i>
    <div class="card-text">
      <p>Augmented & Virtual Reality</p>
      <p>We create immersive AR/VR experiences that engage users and enhance interactivity.</p>
    </div>
  </div>
  <div class="card">
    <i class="fas fa-check-circle"></i>
    <div class="card-text">
      <p>Continuous Support & Evolution</p>
      <p>We provide ongoing maintenance and updates to keep your applications secure, efficient, and future-ready.</p>
    </div>
  </div>
</div>

<div class="sof5">
  <div class="left5">
    <h1 class="left5-title">We Turn Ideas Into<br />Engaging Websites</h1>
    <p class="left5-text">
      We help businesses transform their concepts into high-quality,<br />
      responsive websites. We design, develop, and test web solutions<br />
      while providing QA and consultancy support. We create prototypes<br />
      to validate your ideas quickly, ensuring every website is visually<br />
      appealing, user-friendly, and built to drive results.
    </p>
  </div>
  <div class="right5">
    <img
      src="/img/19.jpg"
      alt="Production Process Image"
      class="right5-image"
    />
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

    
    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay123">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <span style="color: black; font-size: 24px;">CLUTCH</span>
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay123 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }

  .text-overlay123 h2,
  .text-overlay123 button {
    margin-top: 20px; /* Add margin to separate the elements */
  }

  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }
  /* --------------------------------------------------------------------- */
  /* -------------------------------------------- */
  .sof61 {
    width: 100%;
    margin-top: 40px;
    text-align: center;
  }

  .sof61-title {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 2.5em;
    margin-bottom: 20px;
  }

  .cards-container {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .cardlef,
  .cardrig {
    width: 50%;
    padding: 20px;
    text-align: left;
  }
  .cardlef {
    margin-left: 60px;
  }

  .cardlef i,
  .cardrig i {
    font-size: 2em;
    color: #555555;
    margin-right: 10px;
  }

  .cardlef-title,
  .cardrig-title {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1.5em;
    margin-bottom: 10px;
  }

  .company {
    color: #000000;
  }

  .cardlef-description,
  .cardrig-description {
    font-family: "Bree Serif", serif;
    color: #555555;
    font-size: 1em;
    margin-top: 10px;
    line-height: 1.5;
  }
  /* -------------------------------------------- */
  .sof5 {
    display: flex;
    width: 100%;
    margin-top: 40px;
  }

  .left5,
  .right5 {
    width: 50%;
  }

  .left5 {
    background-color: #333333;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .left5-title {
    font-family: "Bree Serif", serif;
    color: #ffffff;
    font-size: 55px;
    margin-bottom: 20px;
    text-align: left;
  }

  .left5-text {
    font-family: "Source Sans Pro", sans-serif;
    color: #ffffff;
    font-size: 1.1em;
    line-height: 1.5;
    text-align: left;
  }

  .right5 {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right5-image {
    width: 100%;
    height: auto;
  }
  /* --------------------------------------------------- */
  .sof4 {
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
  }

  .card {
    display: flex;
    align-items: center;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-left: 40px;
    width: 26%;
    text-align: left;
  }

  .card i {
    font-size: 2em;
    color: #555555;
    margin-right: 10px;
  }

  .card-text {
    font-family: "Bree Serif", serif;
    color: #333333;
  }

  .card-text p {
    margin: 0;
    font-size: 1em;
  }
  /* ------------------------------------------------- */
  .moapp1 {
    position: relative;
    text-align: center;
    width: 100%;
    height: 100vh; /* Ensure the container takes full viewport height */
  }

  .background-image {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensure the image covers the container without stretching */
  }

  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-family: "Bree Serif", serif;
    font-size: 65px;
    font-weight: bold;
  }
  .sof2d {
    display: flex;
    width: 100%;
  }

  .leftso,
  .rightso {
    width: 50%;
  }

  .leftso-image {
    width: 100%;
    height: 600px;
    margin-top: 30px;
  }

  .rightso {
    padding: 20px;
  }

  .rightso-title {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 65px;
    text-align: center;
    margin-bottom: 20px;
  }

  .rightso-content {
    display: flex;
  }

  .leftri,
  .rightri {
    width: 50%;
  }

  .number {
    font-size: 1.5em;
    color: #333333;
    font-family: "Bree Serif", serif;
    margin-bottom: 10px;
  }

  .dev-title {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1.5em;
    margin-bottom: 10px;
  }

  .dev-text {
    font-family: "Bree Serif", serif;
    color: #555555;
    font-size: 1em;
    margin-bottom: 20px;
  }

  @media (min-width: 1040px) and (max-width: 1324px) {
    .sof2d {
      flex-direction: row;
    }

    .leftso,
    .rightso {
      width: 50%;
    }

    .leftso-image {
      height: 500px; /* Adjusted image height */
      margin-top: 20px; /* Reduced margin for better spacing */
    }

    .rightso {
      padding: 20px;
    }

    .rightso-title {
      font-size: 50px; /* Adjusted font size for title */
      margin-bottom: 15px; /* Reduced margin for better spacing */
    }

    .rightso-content {
      flex-direction: row;
    }

    .leftri,
    .rightri {
      width: 50%;
    }

    .number,
    .dev-title,
    .dev-text {
      font-size: 1.2em; /* Adjusted font sizes for content */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }
  }
  @media (min-width: 769px) and (max-width: 1060px) {
    .sof2d {
      flex-direction: column;
      align-items: center;
    }

    .leftso,
    .rightso {
      width: 100%;
    }

    .leftso-image {
      height: 400px; /* Adjusted image height */
      margin-top: 20px; /* Reduced margin for better spacing */
    }

    .rightso {
      padding: 0px;
    }

    .rightso-title {
      font-size: 45px; /* Adjusted font size for title */
      margin-bottom: 15px; /* Reduced margin for better spacing */
    }

    .rightso-content {
      display: flex; /* Ensure flexbox layout */
      flex-direction: row; /* Side by side */
      justify-content: space-between; /* Distribute space evenly */
    }

    .leftri,
    .rightri {
      width: 45%; /* Adjusted width to fit side by side with some gap */
      margin-bottom: 10px; /* Add some margin for spacing */
    }
    .leftri {
      right: 0%;
      margin-left: auto;
      margin-right: 0px;
    }

    .number,
    .dev-title,
    .dev-text {
      font-size: 1.1em; /* Adjusted font sizes for content */
    }
    .card {
      width: 30%; /* Adjusted width for larger screens */
    }
    .sof5 {
      flex-direction: column; /* Stack items vertically */
      align-items: center; /* Center align items */
    }

    .left5,
    .right5 {
      width: 100%; /* Full width for both sides */
      padding: 0px; /* Add padding for better spacing */
      text-align: center; /* Center align text */
    }

    .left5-title {
      font-size: 40px; /* Decrease font size for better readability */
      margin-bottom: 15px; /* Adjust margin for better spacing */
    }

    .left5-text {
      font-size: 1em; /* Adjust font size */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }
    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .sof5 {
      flex-direction: column; /* Stack items vertically */
      align-items: center; /* Center align items */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 15px;
      padding-right: 15px;
      width: 100%;
      box-sizing: border-box;
    }

    .left5,
    .right5 {
      width: 100%; /* Full width for both sides */
      padding: 0 15px; /* Add padding for better spacing */
      text-align: center; /* Center align text */
      margin-left: 0px;
      margin-right: 0px;
      box-sizing: border-box;
    }

    .left5-title {
      font-size: 40px; /* Decrease font size for better readability */
      margin-bottom: 15px; /* Adjust margin for better spacing */
    }

    .left5-text {
      font-size: 1em; /* Adjust font size */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 10px;
      padding-right: 10px;
    }
    .sof2d {
      flex-direction: column;
      align-items: center;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
    }

    .leftso,
    .rightso {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .leftso-image {
      height: 300px; /* Adjusted image height */
      margin-top: 15px; /* Reduced margin for better spacing */
    }

    .rightso {
      padding: 0px;
    }

    .rightso-title {
      font-size: 35px; /* Adjusted font size for title */
      margin-bottom: 10px; /* Reduced margin for better spacing */
    }

    .rightso-content {
      display: flex; /* Ensure flexbox layout */
      flex-direction: row; /* Side by side */
      justify-content: space-between; /* Distribute space evenly */
    }

    .leftri,
    .rightri {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      width: 45%; /* Adjusted width to fit side by side with some gap */
      margin-bottom: 10px; /* Add some margin for spacing */
    }

    .number,
    .dev-title,
    .dev-text {
      font-size: 1em; /* Adjusted font sizes for content */
    }
    .moapp1 {
      height: 100%; /* Adjust as needed */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .background-image {
      height: 100%;
    }

    .text-overlay {
      font-size: 45px; /* Adjust as needed */
    }
    .sof4 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      flex-wrap: wrap; /* Allow cards to wrap to the next line */
      justify-content: center; /* Center align cards */
    }

    .card {
      width: 45%; /* Adjusted width for medium-sized screens */
      margin: 0px; /* Adjusted margin for better spacing */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 0px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }

  /* For screens with a maximum width of 550px */
  @media (max-width: 480px) {
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }
    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .sof5 {
      flex-direction: column; /* Stack items vertically */
      align-items: center; /* Center align items */
      padding-left: 15px;
      padding-right: 15px;
      box-sizing: border-box;
    }

    .left5,
    .right5 {
      width: 100%; /* Full width for both sides */
      padding: 0 15px; /* Add padding for better spacing */
      text-align: center; /* Center align text */
      box-sizing: border-box;
    }

    .left5-title {
      font-size: 40px; /* Decrease font size for better readability */
      margin-bottom: 15px; /* Adjust margin for better spacing */
    }

    .left5-text {
      font-size: 1em; /* Adjust font size */
      padding-left: 10px;
      padding-right: 10px;
    }
    .sof4 {
      flex-direction: column;
      align-items: center;
    }

    .card {
      margin-left: 0;
      margin-bottom: 20px;
      width: 80%; /* Adjusted width for smaller screens */
    }
    .sof2d {
      flex-direction: column;
      align-items: center;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }

    .leftso,
    .rightso {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .leftso-image {
      height: 200px; /* Adjusted image height */
      margin-top: 10px; /* Reduced margin for better spacing */
    }

    .rightso {
      text-align: center;

      padding: 0px;
    }

    .rightso-title {
      font-size: 25px; /* Adjusted font size for title */
      margin-bottom: 10px; /* Reduced margin for better spacing */
    }

    .rightso-content {
      flex-direction: column;
      align-items: center;
      justify-content: center; /* Center content vertically */
    }

    .leftri,
    .rightri {
      width: 100%;
    }

    .number,
    .dev-title,
    .dev-text {
      font-size: 0.9em; /* Adjusted font sizes for content */
    }
    .moapp1 {
      height: 100%; /* Adjust as needed */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }

    .text-overlay {
      font-size: 40px; /* Adjust as needed */
    }
  }

  /* For screens with a maximum width of 350px */
</style>
